export default __webpack_public_path__ + "static/media/Quiken_Envios_Nacionales_Internacionales.3c5717ed.png";